import moment from "moment";

export function elapsedInterval(dateInMs) {

    let date = moment.unix(dateInMs);
    let fromNow = moment(date).fromNow()
    return fromNow;

}